import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Alert(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M13 13a1 1 0 11-2 0V8a1 1 0 112 0v5zm-1 5a1 1 0 110-2.001 1 1 0 010 2zm11.645-.144L14.438 3.435c-1.062-1.913-3.814-1.913-4.876 0L.355 17.855C-.678 19.716.667 22 2.793 22h18.414c2.126 0 3.471-2.285 2.438-4.144z"
  }));
}

export { Alert };
//# sourceMappingURL=Alert.js.map